import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { ApplyTemplateHtmlRequest, DesignPackageItem } from "./dtos";

const DESIGN_PACKAGE_ITEM_SERVICE = `${Constants.API_URL}/bedrock/design_package_items`;

/** Admin-only slide tooling; coaches change slides through the package endpoints. */
export class DesignPackageItemServices {
  /** A new version of the slide from edited template code, as a candidate or approved at once. */
  @scCatchServiceException(true)
  static async createTemplate(itemId: number, request: ApplyTemplateHtmlRequest): Promise<DesignPackageItem> {
    const { data } = await axios.post<DesignPackageItem>(
      `${DESIGN_PACKAGE_ITEM_SERVICE}/${itemId}/design_templates`,
      request
    );
    return data;
  }
}
